
import { useCallback } from 'react';
import { toast } from 'sonner';
import { AttendanceStatus } from '../../store/attendanceStore';
import { useTimetableStore } from '../../store/timetableStore';
import { isToday, format } from 'date-fns';

export const useAttendanceActions = () => {
  const { updateClassStatus } = useTimetableStore();

  const syncAttendanceWithTimetable = useCallback(async (
    teacherId: string, 
    status: AttendanceStatus,
    timetableData: any[],
    substitute?: { id: string, name: string }
  ) => {
    if (!timetableData || !Array.isArray(timetableData)) return;
    
    const teacherIndex = timetableData.findIndex(t => t.id === teacherId);
    if (teacherIndex === -1) return;
    
    const teacherClasses = timetableData[teacherIndex].classes;
    if (!teacherClasses || !Array.isArray(teacherClasses)) return;
    
    for (const classItem of teacherClasses) {
      try {
        const classDate = new Date(classItem.startTime);
        if (isToday(classDate)) {
          await updateClassStatus(teacherId, classItem.id, status);
        }
      } catch (error) {
        console.error('Error updating class status:', error);
      }
    }
  }, [updateClassStatus]);

  return {
    syncAttendanceWithTimetable
  };
};
